/* global google */
import {Polygon as GooglePolygon} from "react-google-maps";
import * as _constants from "react-google-maps/lib/constants";


class Polygon extends GooglePolygon {
  getBounds() {
    let bounds = new google.maps.LatLngBounds();
    let paths = this.state[_constants.POLYGON].getPaths();
    let path;

    for (let p = 0; p < paths.getLength(); p++) {
      path = paths.getAt(p);
      for (let i = 0; i < path.getLength(); i++) {
        bounds.extend(path.getAt(i));
      }
    }

    return bounds;
  }
}

export default Polygon;
